import React from 'react'
import BrandName from './BrandName'
import { ProfilerQuestionID } from '../../config/QuestionEnum'
import { getQuestionConfig } from '../../config/questionsConfig';
import { PROFILER_IMAGES } from '../../Common/constants';
const questionConfig = getQuestionConfig(ProfilerQuestionID.BCM_PAINT_AND_HARDWARE_BRANDS);

const BCMBrandPaintAndHardware = (props) => {
  return (
    <BrandName
      questionId={ProfilerQuestionID.BCM_PAINT_AND_HARDWARE_BRANDS}
      title={questionConfig?.question}
      subtitle={questionConfig?.subtitle}
      options={questionConfig?.options || []}
      suggestions={['Asian Paints', 'Berger Paints', 'Kansai Nerolac', 'Indigo Paints', 'Dulux']}
      icon={PROFILER_IMAGES.paint}
      {...props}
    />
  )
}

export default BCMBrandPaintAndHardware
